import React from "react";

export default function UploadDocumentsModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-2xl max-w-md w-full shadow-xl">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-serif">Ajouter des documents</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-black">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="text-center text-gray-600 mb-8">
          <p className="text-sm">La fonctionnalité d'upload sera disponible bientôt.</p>
          <p className="text-xs mt-2">Merci de votre patience ✨</p>
        </div>

        <div className="flex justify-end">
          <button
            onClick={onClose}
            className="btn-artsy btn-primary-artsy"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
}
